import React, { Component } from 'react'
import classNames from 'classnames'
import { Link } from 'react-router-dom'

//import Tooltip from '../Tooltip'
import Loading from '../Loading'

import styles from './Icon.module.css'
import buttonStyles from './IconButton.module.css'

export default function Icon(props) {
  const { icon, big, color, placeholder, className, ...otherProps } = props

  return (
    <span
      {...otherProps}
      className={classNames(styles.icon, className, styles[`icon-${icon}`], {
        [styles.big]: big,
        [styles.placeholder]: placeholder,
        [styles[`color-${color}`]]: color,
      })}
    />
  )
}

export class IconButton extends Component {
  renderContent() {
    let {
      onClick,
      large,
      disabled,
      className,
      loading,
      to,
      href,
      color,
      expanded,
      ...props
    } = this.props

    let IconButton = to ? Link : href ? 'a' : 'div'

    return (
      <IconButton
        className={classNames(buttonStyles.wrapper, className, {
          [buttonStyles[`color-${color}`]]: color,
          [buttonStyles.large]: large,
          [buttonStyles.disabled]: disabled,
          [buttonStyles.active]: expanded,
        })}
        onClick={onClick}
        to={to}
        href={href}
        rel={href ? 'noopener noreferrer' : null}
      >
        {loading ? <Loading small /> : <Icon {...props} color={color} />}
      </IconButton>
    )
  }

  render() {
    // let { tooltip } = this.props

    // if (tooltip) {
    //   return (
    //     <Tooltip placement="top" tooltip={tooltip}>
    //       {this.renderContent()}
    //     </Tooltip>
    //   )
    // }

    return this.renderContent()
  }
}
